import { render } from "./ImageGalleryMobile.vue?vue&type=template&id=07a22431&ts=true"
import script from "./ImageGalleryMobile.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryMobile.vue?vue&type=script&lang=ts"

import "./ImageGalleryMobile.vue?vue&type=style&index=0&id=07a22431&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__